// extracted by mini-css-extract-plugin
module.exports = {"link-button":"_1c9529d521--link-button--ujZuh"};